<template lang="pug">
server-data(
  v-model="items"
  search-field-name="search[name]"
  :method="getMunicipality"
  :start-loading-value="true"
  v-slot="{ loading: isLoading, search }"
)
  ev-autocomplete(
    v-model="inputValue"
    v-bind="$attrs"
    v-on="$listeners"
    item-text="name"
    item-value="id"
    :items="items"
    :loading="isLoading"
    :return-object="returnObject"
    :clearable="clearable"
    @update:search-input="search"
  )
    template(#prepend-inner)
      slot(name="prepend-inner")
</template>

<script>
import { PER_PAGE } from '@/constants/pagination';

export default {
  name: 'DirectoryMunInput',
  props: {
    value: {
      type: [Object, Number, String],
      default: null,
    },
    region: {
      type: [Number, String],
      default: null,
    },
    returnObject: {
      type: Boolean,
      default: true,
      required: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    onlyWhenHaveRegion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    inputValue: {
      get() {
        return !Number.isNaN(this.parsedValue) ? this.parsedValue : this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    parsedValue() {
      return parseInt(this.value);
    },
    isHaveRegion() {
      return this.onlyWhenHaveRegion && !this.region;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (!value || this.items.includes((item) => item.id === value) || !this.parsedValue) {
          return;
        }

        this.$rApi.directories.showMun({ args: [value] }).then(({ response }) => {
          this.items.push(response.data.data);
          this.$emit('load:mun', response.data.data);
        });
      },
    },
  },
  methods: {
    getMunicipality(additionalParams = {}) {
      // if (this.isHaveRegion) {
      //   this.items = [];
      //   return;
      // }

      const params = {
        ...additionalParams?.params,
        sort: 'name',
        'search[region_id]': this.region,
        'per-page': PER_PAGE.infinity,
      };

      return this.$api.dir.getMunsCached(params);
    },
  },
};
</script>
